export const KILOBYTE = 1000;
export const MEGABYTE = 1000 * KILOBYTE;

// The 250MB limit comes from the back-end
export const UPLOAD_MEGABYTE_LIMIT = 250;